<template>
    <div class="container" v-if="banner[params.bannerKey]&&banner.page==1">
        <img :src="banner[params.bannerKey].mobile" v-if="($store.state.global.screenWidth * 1 < 880)&&banner[params.bannerKey].mobile">
        <img :src="banner[params.bannerKey].desctop" v-if="($store.state.global.screenWidth * 1 >= 880)&&banner[params.bannerKey].desctop">
    </div>
</template>
<script>
import {defineComponent} from 'vue'
import {mapState} from "vuex";

export default defineComponent({
    name: "top_banner",
    props:['params'],
    selector: ".top_banner",
    computed:{
        ...mapState({
            banner: ({banner}) => banner?.data,
        }),
    }
})
</script>


<style scoped lang="scss">
.container{
  margin-top: 15px;
  img {
    width: 100%;
  }
}

</style>